import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ChevronLeft } from "lucide-react";
import api, { fileUrl, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function ForgotPassword() {
  const { branding } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="phone-wrap">
      <div className="phone-frame flex flex-col">
        <div className="relative">
          <img src={fileUrl(branding?.login_hero)} alt="Alpha Tattoo Club" className="w-full h-44 object-cover border-b-2 border-black" />
          <button onClick={() => navigate("/auth")} className="absolute top-3 left-3 bg-[#F4F0E6] border-2 border-black rounded-full p-1" data-testid="forgot-back">
            <ChevronLeft size={20} />
          </button>
        </div>
        <div className="p-6 flex-1">
          <span className="eyebrow">Account Recovery</span>
          <h1 className="font-display font-black text-3xl uppercase leading-none mb-4">Reset Password</h1>
          {sent ? (
            <div className="atc-card p-5" data-testid="forgot-confirm">
              <p className="font-body text-sm">If that email is registered, we've sent a reset link. Check your inbox and follow the link within 1 hour.</p>
              <button className="atc-btn btn-primary w-full mt-4" onClick={() => navigate("/auth")} data-testid="forgot-signin">Back To Sign In</button>
            </div>
          ) : (
            <form onSubmit={submit} className="flex flex-col gap-3">
              <p className="text-sm text-[#554E40]">Enter your email and we'll send a link to set a new password.</p>
              <input className="atc-input" type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="forgot-email" />
              {error && <p className="text-[#8B1E28] text-sm font-bold">{error}</p>}
              <button type="submit" className="atc-btn btn-primary" disabled={busy} data-testid="forgot-submit">
                {busy ? <Loader2 size={18} className="animate-spin" /> : null} Send Reset Link
              </button>
              <button type="button" className="w-full text-center mt-1 font-mono2 text-xs underline text-[#554E40]" onClick={() => navigate("/auth")} data-testid="forgot-back-link">Back to sign in</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
